exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spectacle-deck .exit{height:100%;flex-direction:column}.spectacle-deck .exit,.spectacle-deck .exit .button-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;-ms-flex-align:center;align-items:center}.spectacle-deck .exit .button-group{flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex:1;flex:1;padding:.5em .5em 2em;width:100%}.spectacle-deck .exit .button-group p{text-align:center}@media (min-width:1600px){.spectacle-deck .exit .button-group p{font-size:1.4em}}.spectacle-deck .exit .btn-lg{margin:1em;min-height:1em}@media (max-width:400px){.spectacle-deck .exit .btn-sm{white-space:normal;padding:10px;line-height:13px}}.spectacle-deck .teacher-remote .exit .btn-lg,.spectacle-deck .teacher-remote .exit .btn-sm{width:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/hudTeacherRemote/exit/exit.scss
// module id = 1299
// module chunks = 2